export const SCROLL_TO_TARGET_HEADER = 'header';
export const SCROLL_TO_TARGET_MOBILE_TAB_BAR = 'mobile-tab-bar';
export const SCROLL_TO_TARGET_ANCHOR_NAV = 'anchor-nav';
export const SCROLL_TO_TARGET_FOOTER = 'footer';
export const getTarget = (target) => document.querySelector(`[data-scroll-to-target="${target}"]`);
/**
 * Alternative to window.scrollTo that accounts for site layout
 * Accepts an optional callback to run after scroll ends (only for smooth scroll)
 */
export function scrollTo(element, { accountForHeader = true, accountForAnchorNav = true, behavior = 'smooth' } = {}, callback) {
    if (typeof element === undefined || element === null) {
        console.warn('scrollTo element not found', element);
        return;
    }
    const containerTop = typeof element === 'number' ? element : (element?.getBoundingClientRect().top ?? 0);
    const documentTop = document.documentElement.scrollTop;
    let top = containerTop + documentTop;
    if (accountForHeader) {
        top -= getTarget(SCROLL_TO_TARGET_HEADER)?.clientHeight ?? 0;
    }
    if (accountForAnchorNav) {
        top -= getTarget(SCROLL_TO_TARGET_ANCHOR_NAV)?.clientHeight ?? 0;
    }
    window.scrollTo({
        top,
        behavior,
    });
    if (behavior === 'smooth' && typeof callback === 'function') {
        let sameCount = 0;
        let frameCount = 0;
        const maxFrames = 120;
        let called = false;
        const checkScroll = () => {
            frameCount++;
            if (Math.abs(window.scrollY - top) < 2) {
                sameCount++;
                if (sameCount > 2 && !called) {
                    called = true;
                    callback();
                    return;
                }
            }
            else {
                sameCount = 0;
            }
            if (frameCount > maxFrames && !called) {
                called = true;
                callback();
                return;
            }
            requestAnimationFrame(checkScroll);
        };
        checkScroll();
    }
    else if (typeof callback === 'function') {
        callback();
    }
}
